import { Menu, Transition } from "@headlessui/react";
import {
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronUpDownIcon,
    StopIcon,
} from "@heroicons/react/24/outline";
import { Fragment, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import es from "date-fns/locale/es";

const WEEK_DAYS = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
];
const MONTHS = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
];

export default function DayCalendar({ selectedDate, setSelectedDate }) {
    const handleChange = (e) => {
        setSelectedDate(e);
    };

    const goPrevDay = () => {
        setSelectedDate(
            new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth(),
                selectedDate.getDate() - 1
            )
        );
    };

    const goNextDay = () => {
        setSelectedDate(
            new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth(),
                selectedDate.getDate() + 1
            )
        );
    };

    const goToday = () => {
        setSelectedDate(new Date());
    };

    const dayName = WEEK_DAYS[selectedDate.getDay()];
    const day = selectedDate.getDate();
    const month = MONTHS[selectedDate.getMonth()];
    const year = selectedDate.getFullYear();

    return (
        <div className="flex flex-col gap-2 max-h-44 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-3 w-72">
            <div className="flex justify-around items-center w-full">
                <Menu as="div">
                    <Menu.Button>
                        <div className="flex items-center justify-center hover:text-blue-400 dark:hover:text-blue-400 transition-all ">
                            {month} {year}
                            <ChevronUpDownIcon className="h-6 w-6" />
                        </div>
                    </Menu.Button>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className="absolute z-10 mt-2 w-64 origin-top-right rounded-md bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <DatePicker
                                selected={selectedDate}
                                onChange={handleChange}
                                locale={es}
                                inline
                            />
                        </Menu.Items>
                    </Transition>
                </Menu>
                <div className="flex">
                    <button
                        onClick={goPrevDay}
                        className="text-gray-600 dark:text-gray-400 p-1 hover:text-blue-400 dark:hover:text-blue-400 transition-all "
                    >
                        <ChevronLeftIcon className="h-6 w-6" />
                    </button>
                    <button
                        onClick={goToday}
                        className="text-gray-600 dark:text-gray-400 p-1 hover:text-blue-400 dark:hover:text-blue-400 transition-all ">
                        <StopIcon className="h-6 w-6" />
                    </button>
                    <button
                        onClick={goNextDay}
                        className="text-gray-600 dark:text-gray-400 p-1 hover:text-blue-400 dark:hover:text-blue-400 transition-all "
                    >
                        <ChevronRightIcon className="h-6 w-6" />
                    </button>
                </div>
            </div>
            <h2 className="text-3xl text-gray-800 dark:text-gray-200 font-semibold text-center">
                {dayName} {day}
            </h2>
        </div>
    );
}
